export default {
  meta: {
    title: '附属流程配置',
  }
};
